// extracted by mini-css-extract-plugin
export var container = "_sa-0";
export var table = "_sa-2";
export var tableWrapper = "_sa-1";